<template>
  <select class="form-control" :class="{'is-invalid': layoutData.errorText != null}" @change="onChange" v-model="valueData" style="width: initial">
    <option v-for="(option, index) in options" :key="index" :value="option.value">{{option.label}}</option>
  </select>
</template>

<script>
  export default {
    name: "timesheet-field-dropdown",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      options() {
        return this.layoutData.options
      }
    },
    methods: {
      onChange(e) {
        this.$emit("change", e, this.layoutData, this.valueData, this.index);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>